import * as FC from "@fluentui/react-components";
import { useCommonStyles } from "../../style_util";
import { useState } from "react";
import { getCurrentUser } from "../../services/login";
import { ModelLeafManagement } from "./business/model_leaf";
import { ManuLeafManagement } from "./business/manu_leaf";
import { ModelTurbineManagement } from "./business/model_turbine";
import { ManuTurbineManagement } from "./business/manu_turbine";
import { DefDefectionManagement } from "./business/def_defection";
export const BusinessManagement = () => {
    const [currentTab, setCurrentTab] = useState("model_leaf");
    const currentUser = getCurrentUser();
    const role = currentUser.role;
    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.root}>
            <FC.TabList
                selectedValue={currentTab}
                onTabSelect={(evt, data) => setCurrentTab(data.value)}
            >
                <FC.Tab value="model_leaf">叶片型号</FC.Tab>
                <FC.Tab value="manu_leaf">叶片制造商</FC.Tab>
                <FC.Tab value="model_turbine">风机型号</FC.Tab>
                <FC.Tab value="manu_turbine">风机制造商</FC.Tab>
{role?.toLowerCase() === "admin" &&               <FC.Tab value="def_defection">缺陷类型</FC.Tab> } 
            </FC.TabList>
            {currentTab === "model_leaf" && <ModelLeafManagement />}
            {currentTab === "manu_leaf" && <ManuLeafManagement />}
            {currentTab === "model_turbine" && <ModelTurbineManagement />}
            {currentTab === "manu_turbine" && <ManuTurbineManagement />}
            {currentTab === "def_defection" && <DefDefectionManagement />} 
        </div>
    );
};
